import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    rulesListLoading: false,
    rulesListSuccess: null,
    rulesListError: '',
    ruleDetailLoading: false,
    ruleDetailSuccess: null,
    ruleDetailError: '',
    viewRuleDetailLoading: false,
    viewRuleDetailSuccess: null,
    viewRuleDetailERror: '',
}

export const rulesSlice = createSlice({
    name: 'rules',
    initialState,
    reducers: {
        setRulesListLoading: (state) => {
            state.rulesListLoading = true;
            state.rulesListSuccess = null;
            state.rulesListError = '';
        },
        setRulesListSuccess: (state, action) => {
            state.rulesListLoading = false;
            state.rulesListSuccess = action.payload;
            state.rulesListError = '';
        },
        setRulesListError: (state, action) => {
            state.rulesListLoading = false;
            state.rulesListSuccess = null;
            state.rulesListError = action.payload;
        },
        getRuleDetailsLoading: (state) => {
            state.ruleDetailLoading = true;
            state.ruleDetailSuccess = null;
            state.ruleDetailError = '';
        },
        getRuleDetailsSuccess: (state, action) => {
            state.ruleDetailLoading = false;
            state.ruleDetailSuccess = action.payload;
            state.ruleDetailError = '';
        },
        getRuleDetailsError: (state, action) => {
            state.ruleDetailLoading = false;
            state.ruleDetailSuccess = null;
            state.ruleDetailError = action.payload;
        },
        setViewRuleDetailsLoading: (state) => {
            state.viewRuleDetailLoading = true;
            state.viewRuleDetailSuccess = null;
            state.viewRuleDetailERror = '';
        },
        setViewRuleDetailsSuccess: (state, action) => {
            state.viewRuleDetailLoading = false;
            state.viewRuleDetailSuccess = action.payload;
            state.viewRuleDetailERror = '';
        },
        setViewRuleDetailsError: (state, action) => {
            state.viewRuleDetailLoading = false;
            state.viewRuleDetailSuccess = null;
            state.viewRuleDetailERror = action.payload;
        },
        resetRule : (state, action) => {
            state.ruleDetailSuccess = null;
        }
    },
})

export const {
    setRulesListLoading, setRulesListSuccess, setRulesListError,
    getRuleDetailsLoading, getRuleDetailsSuccess, getRuleDetailsError,resetRule,
    setViewRuleDetailsLoading, setViewRuleDetailsSuccess, setViewRuleDetailsError
} = rulesSlice.actions

export default rulesSlice.reducer;